// Module
var code = "<template>\n  <require from=\"../../../../features/mooring/mooring-article-container\"></require>\n\n  <mooring-article-container></mooring-article-container>\n</template>\n";
// Exports
export default code;